module.exports = __webpack_public_path__ + "static/media/icon_next.ef128a69.svg";